export default __webpack_public_path__ + "aaa7a7344568df7359f4926f20edd6e5.png";